module.exports = __webpack_public_path__ + "static/media/cop.8d5f444d.png";